import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brwr-footer-view" }
const _hoisted_2 = { class: "mobile-only" }
const _hoisted_3 = { class: "menu-list" }
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "POLICIES", -1)
const _hoisted_6 = { class: "menu faq-brwr-mobile" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "Support", -1)
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 문의하기 ")
const _hoisted_10 = { style: {"font-weight":"400"} }
const _hoisted_11 = { style: {"font-weight":"400"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item faq-detail" }, [
  /*#__PURE__*/_createTextVNode(" 평일 10:00 ~ 17:00 (점심 12:40 ~ 13:40)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 주말, 공휴일 제외 ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("article", { class: "footer-article-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-article" }, [
    /*#__PURE__*/_createTextVNode(" 상호 : 앱솔브트러스트 I 도로명주소 : 서울특별시 송파구 송파대로 201, 테라타워2 B동 1층 117호 I 사업자등록번호 : 758-81-02431 I 대표자명 : 황성배"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "footer-article" }, [
    /*#__PURE__*/_createTextVNode(" 대출금리 연 20% 이내(연체금리 연 20% 이내) 채무의 조기상환 수수료율 등 조기상환 조건 없으며 플랫폼 이용료, 법무비 등 부대비용 별도 부담입니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 중개수수료를 요구하거나 받는 것은 불법입니다. 과도한 빚은 당신에게 큰 불행을 안겨 줄 수 있습니다. 대출 시 귀하의 신용등급이 하락할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 트러스트펀드는 투자 원금과 수익을 보장하지 않으며, 투자손실에 대한 책임은 모두 투자자에게 있습니다. ")
  ])
], -1)
const _hoisted_14 = { class: "desktop-only" }
const _hoisted_15 = { class: "menu-list-desktop" }
const _hoisted_16 = { class: "menu-brwr-desktop" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "POLICIES", -1)
const _hoisted_18 = { class: "menu-brwr-desktop" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "Support", -1)
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 문의하기 ")
const _hoisted_22 = { style: {"font-weight":"400"} }
const _hoisted_23 = { style: {"font-weight":"400"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item faq-detail" }, [
  /*#__PURE__*/_createTextVNode(" 평일 10:00 ~ 17:00 (점심 12:40 ~ 13:40)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 주말, 공휴일 제외 ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("article", { class: "footer-article-list" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-article" }, [
    /*#__PURE__*/_createTextVNode(" 상호 : 앱솔브트러스트 I 도로명주소 : 서울특별시 송파구 송파대로 201, 테라타워2 B동 1층 117호 I 사업자등록번호 : 758-81-02431 I 대표자명 : 황성배"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "footer-article" }, [
    /*#__PURE__*/_createTextVNode(" 대출금리 연 20% 이내(연체금리 연 20% 이내) 채무의 조기상환 수수료율 등 조기상환 조건 없으며 플랫폼 이용료, 법무비 등 부대비용 별도 부담입니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 중개수수료를 요구하거나 받는 것은 불법입니다. 과도한 빚은 당신에게 큰 불행을 안겨 줄 수 있습니다. 대출 시 귀하의 신용등급이 하락할 수 있습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 트러스트펀드는 투자 원금과 수익을 보장하지 않으며, 투자손실에 대한 책임은 모두 투자자에게 있습니다. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_phone_outlined = _resolveComponent("phone-outlined")!
  const _component_mail_outlined = _resolveComponent("mail-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_divider),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ name: 'termsofservicebrwr' })))
          }, " 이용약관 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover fw-700",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: 'personalcreditpolicybrwr' })))
          }, " 개인정보처리방침 "),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'termsoflinkedloancontractbrwr' }))),
            class: "menu-item pointer-hover"
          }, " 연계대출계약 표준약관 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({ name: 'personalinfosys' })))
          }, " 신용정보 활용체제 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({ name: 'codeofethicsforexctsandemplsbrwr' })))
          }, " 임직원 윤리강령 ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", {
              class: "phone-num pointer-hover",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.callFaq && _ctx.callFaq(...args)))
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_phone_outlined)
              ]),
              _createTextVNode("  " + _toDisplayString(_ctx.phoneNum), 1)
            ]),
            _createElementVNode("div", {
              class: "phone-num pointer-hover",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mailFaq && _ctx.mailFaq(...args)))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_mail_outlined),
                _createTextVNode("  " + _toDisplayString(_ctx.email), 1)
              ])
            ])
          ]),
          _hoisted_12
        ])
      ]),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_a_divider),
      _createElementVNode("nav", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.push({ name: 'termsofservicebrwr' })))
          }, " 이용약관 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover fw-700",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.router.push({ name: 'personalcreditpolicybrwr' })))
          }, " 개인정보처리방침 "),
          _createElementVNode("div", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.router.push({ name: 'termsoflinkedloancontractbrwr' }))),
            class: "menu-item pointer-hover"
          }, " 연계대출계약 표준약관 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.router.push({ name: 'personalinfosysbrwr' })))
          }, " 신용정보 활용체제 "),
          _createElementVNode("div", {
            class: "menu-item pointer-hover",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.router.push({ name: 'codeofethicsforexctsandemplsbrwr' })))
          }, " 임직원 윤리강령 ")
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              class: "phone-num pointer-hover",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.callFaq && _ctx.callFaq(...args)))
            }, [
              _createElementVNode("span", _hoisted_22, [
                _createVNode(_component_phone_outlined)
              ]),
              _createTextVNode("  " + _toDisplayString(_ctx.phoneNum), 1)
            ]),
            _createElementVNode("div", {
              class: "phone-num pointer-hover",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.mailFaq && _ctx.mailFaq(...args)))
            }, [
              _createElementVNode("span", _hoisted_23, [
                _createVNode(_component_mail_outlined),
                _createTextVNode("  " + _toDisplayString(_ctx.email), 1)
              ])
            ])
          ]),
          _hoisted_24
        ])
      ]),
      _hoisted_25
    ])
  ]))
}